<template>
  <v-app>
    <router-view />
  </v-app>
</template>
<style>
body {
  background: linear-gradient(to bottom right, #ffffff, #f0f8ff);
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.v-application {
  background-color: transparent !important;
}
</style>